import { render, staticRenderFns } from "./listClient.vue?vue&type=template&id=e92fbbb4&"
import script from "./listClient.vue?vue&type=script&lang=js&"
export * from "./listClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports